import { render, staticRenderFns } from "./AffirmLogin.vue?vue&type=template&id=188897fe&"
import script from "./AffirmLogin.vue?vue&type=script&lang=js&"
export * from "./AffirmLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports